<template>
  <div class="fx_content">

    <div class="fenxi_con">
      <a-row class="juzhong">
        <a-col :span="8">
          <div class="dct"><img src="@/assets/dc1.png"></div>
          <div class="dcph">NO-1</div>
          <div>兰州荒滩2号站</div>
        </a-col>
        <a-col :span="8">
          <div class="dct"><img src="@/assets/dc2.png"></div>
          <div class="dcph">NO-2</div>
          <div>庆阳移动大楼</div>
        </a-col>
        <a-col :span="8">
          <div class="dct"><img src="@/assets/dc3.png"></div>
          <div class="dcph">NO-3</div>
          <div>张掖市政府站</div>
        </a-col>
      </a-row>

      <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "DianChi",
  components: {},
  props: {},
  setup() {
    let data1 = [
      {
        name: "兰州黄滩2号站",
        value: 175.17,
      },
      {
        name: "庆阳移动大楼站",
        value: 148.35,
      },
      {
        name: "张掖市政府站",
        value: 95.36,
      },
    ];
    let xAxisData = [];
    let seriesData = [];
    let seriesData1 = [];
    let ciolData = [];
    let sum = 0;
    let bottomData = [];
    let topData = [];
    let ciolColor1 = [
      "rgba(8, 177, 255, 1)",
      "rgba(0, 255, 136,   1)",
      //'rgba(8, 177, 255, 1)',
      "rgba(251, 171, 88,   1)",
      "rgba(8, 177, 255, 1)",
      "rgba(251, 171, 88,   1)",
      "rgba(8, 177, 255, 1)",
      "rgba(251, 171, 88,   1)",
    ];
    let ciolColor0 = [
      "rgba(107, 255, 243,  1)",
      "rgba(97,253,196,  1)",

      //'rgba(107, 255, 243,  1)',
      "rgba(253, 221, 97,  1)",

      "rgba(107, 255, 243,  1)",
      "rgba(253, 221, 97,  1)",
      "rgba(107, 255, 243,  1)",
      "rgba(253, 221, 97,  1)",
    ];
    let bottomColor0 = [
      "rgba(8, 177, 255, 0.8)",
      "rgba(0, 255, 136, 0.8)",

      //'rgba(8, 177, 255, 0.8)',
      "rgba(251, 171, 88, 0.8)",

      "rgba(8, 177, 255, 0.8)",
      "rgba(251, 171, 88, 0.8)",
      "rgba(8, 177, 255, 0.8)",
      "rgba(251, 171, 88, 0.8)",
    ];
    let bottomColor1 = [
      "rgba(107, 255, 243, 0.8)",
      "rgba(100,253,212,0.8)",

      //'rgba(107, 255, 243, 0.8)',
      "rgba(253, 227, 100,0.8)",

      "rgba(107, 255, 243, 0.8)",
      "rgba(253, 227, 100,0.8)",
      "rgba(107, 255, 243, 0.8)",
      "rgba(253, 227, 100,0.8)",
    ];
    let header0 = [
      "rgba(8, 177, 255, 1)",
      "rgba(0, 255, 136, 1)",

      //'rgba(8, 177, 255, 1)',
      "rgba(251, 171, 88, 1)",

      "rgba(8, 177, 255, 1)",
      "rgba(251, 171, 88, 1)",
      "rgba(8, 177, 255, 1)",
      "rgba(251, 171, 88, 1)",
    ];
    let header1 = [
      "rgba(107, 255, 243, 1)",
      "rgba(100,253,212,1)",

      //'rgba(107, 255, 243, 1)',
      "rgba(253, 227, 100,1)",

      "rgba(107, 255, 243, 1)",
      "rgba(253, 227, 100,1)",
      "rgba(107, 255, 243, 1)",
      "rgba(253, 227, 100,1)",
    ];
    let bottom = [
      "rgba(31, 194, 252, 0.4)",
      "rgba(0, 255, 136, 0.4)",
      //'rgba(31, 194, 252, 0.4)',
      "rgba(253, 179, 88, 0.4)",
      "rgba(31, 194, 252, 0.4)",
      "rgba(253, 179, 88, 0.4)",
      "rgba(31, 194, 252, 0.4)",
      "rgba(253, 179, 88, 0.4)",
      "rgba(31, 194, 252, 0.4)",
      "rgba(253, 179, 88, 0.4)",
    ];

    data1.forEach((item) => {
      xAxisData.push(item.name);
      seriesData.push(item.value);
      seriesData1.push({ name: "", value: item.value });
      ciolData.push({ name: "", value: "0" });
      sum += item.value;
    });
    data1.forEach((item) => {
      bottomData.push({ name: "", value: sum - item.value });
      topData.push({ name: "", value: sum });
    });
    const options = ref({
      grid: {
        top: "2%",
        left: "5%",
        right: "5%",
        bottom: "45%",
      },
      // tooltip: {
      //   show: true,

      //   formatter: (params) => {
      //       return v2L2Chart.xData[params.dataIndex] + ':' + v2L2Chart.data[params.dataIndex] + '万';

      //   },
      //   backgroundColor: "rgba(38, 68, 110, 0.8)",
      //   padding: 10,
      //   borderColor: "rgba(38, 68, 110, 1)",
      //   textStyle: {
      //     color: "#fff",
      //   },
      // },

      xAxis: {
        offset: 20,
        data: xAxisData,
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
      },
      yAxis: {
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: [
        //'最低下的圆片',
        {
          // name: "最低下的圆片",
          stack: "a",
          // type: 'pictorialBar',
          // symbolSize: [66, 12],
          // symbolOffset: [0, 6],
          type: "effectScatter",
          symbolSize: [62, 12],
          symbolOffset: [0, 0],
          z: 22,
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: ciolColor0[params.dataIndex],
                  },
                  {
                    offset: 0,
                    color: ciolColor1[params.dataIndex],
                  },
                ]);
              },
            },
          },
          data: ciolData,
        },
        //下半截柱状图
        {
          // name: "下半截柱状图",
          stack: "a",
          type: "bar",
          barWidth: 66,
          z: 2,
          barGap: "-100%",
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: bottomColor1[params.dataIndex],
                  },
                  {
                    offset: 0,
                    color: bottomColor0[params.dataIndex],
                  },
                ]);
              },
            },
          },
          data: seriesData1,
        },
        //替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20'
        {
          // name: "替代柱状图 默认不显示颜色，是最下方柱图的value值 - 20",
          // stack: '',
          type: "bar",
          barWidth: 66,
          barGap: "-100%",
          // stack: '广告',
          itemStyle: {
            color: "transparent",
          },
          data: seriesData,
        },
        //头部1
        {
          //name: "头部1",
          stack: "a",
          type: "pictorialBar",
          symbolSize: [66, 12],
          symbolOffset: [0, -6],
          z: 22,
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: header1[params.dataIndex],
                  },
                  {
                    offset: 0,
                    color: header0[params.dataIndex],
                  },
                ]);
              },
            },
          },
          symbolPosition: "end",

          data: seriesData1,
        },
        //头部2
        {
          // name: "头部2",
          stack: "a",
          type: "pictorialBar",
          symbolSize: [66, 12],
          symbolOffset: [0, -6],
          symbolPosition: "end",
          z: 22,
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: header1[params.dataIndex],
                  },
                  {
                    offset: 0,
                    color: header0[params.dataIndex],
                  },
                ]);
              },
            },
          },
          label: {
            formatter: (params) => {
              var i = params.dataIndex + 1;
              return "NO." + i;
            },
            //formatter: "NO.{c}",
            color: "#fff",
            offset: [0, 0],
            show: true,
            position: "top",
            fontSize: 15,
            fontWeight: 400,
            fontFamily: "zcool-gdh",
          },
          data: topData,
        },
        //底色
        {
          //name: "底色",
          stack: "a",
          type: "bar",
          barWidth: 66,
          z: 2,
          barGap: "-100%",
          // stack: '',
          symbolPosition: "end",
          itemStyle: {
            normal: {
              color: function (params) {
                return bottom[params.dataIndex];
              },
            },
          },
          data: bottomData,
        },
      ],
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
    });

    return {
      options,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fx_content {
  position: relative;
  /*相对位置*/
  height: calc(100% - 15px);
}

.dct {
  position: relative;
  margin-bottom: 20px;
}

.dcph {
  position: absolute;
  text-align: center;
  top: 70px;
  left: 46px;
}

.juzhong {
  text-align: center;
  color: #fff;
  padding-top: 25px
}

.fenxi {
  background: url("@/assets/conbg.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}

.fenxi_con {
  width: 100%;
  position: absolute;
  height: 100%;
}

.title {
  color: #5ce7f0;
  font-size: 16px;
  padding: 10px 30px 10px 50px;
  background: url("@/assets/biao.png") 10px 5px;
  background-repeat: no-repeat;
}
</style>
